import { render, staticRenderFns } from "./CmgGroupOrderConfirmation.vue?vue&type=template&id=b2a7dbd8&scoped=true&lang=pug&"
import script from "./cmg-group-order-confirmation.ts?vue&type=script&lang=ts&"
export * from "./cmg-group-order-confirmation.ts?vue&type=script&lang=ts&"
import style0 from "./CmgGroupOrderConfirmation.vue?vue&type=style&index=0&id=b2a7dbd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a7dbd8",
  null
  
)

export default component.exports